
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5","stroke":"#FFF"}}),_c('text',{attrs:{"fill":"#FFF","font-family":"NotoSansCJKkr-Regular, Noto Sans CJK KR","font-size":"10"}},[_c('tspan',{attrs:{"x":"4.81","y":"12"}},[_vm._v("C")])])])])
      }
    
      }
    